import { useTable, useRowSelect } from "react-table";

export default function TableWithoutSpecials ({columns, data, hiddenColumns, additionalColumns, reloadData}) {

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows,
      } = useTable(
        {
          columns,
          data,
          reloadData,
          initialState: {
              hiddenColumns: hiddenColumns,
          }
        },
        useRowSelect,
        hooks => {
            hooks.visibleColumns.push(columns => [
                ...columns,
                additionalColumns
            ])
        }
      )

    return (
        <>
        <table {...getTableProps()} className="general-table">
            <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()} key="headergroup">
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()} key={column.render('Header')} style={{border: "1px solid whitesmoke", width: `${columns.filter(col => col.Header === column.render('Header')).map(c => c.width)}`}}>
                                {column.render('Header')}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()} className="general-table-body" key="body">
                {rows.map((row, i) => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()} key={i} className={i % 2 === 0 ? "even-page" : "odd-page"}>
                            {row.cells.map(cell => {
                                return <td {...cell.getCellProps()} key={`${i}-${cell.render('Header')}`} className="general-table-cell" style={{width: `${columns.filter(col => col.Header === cell.render('Header')).map(c => c.width)}`}}>
                                            {cell.render('Cell')} </td>
                                }
                            )}
                        </tr>
                    )
                })}
            </tbody>
        </table>
        </>
    )    
}
